import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  ConfigProvider,
  Input,
  Row,
  Typography,
  DatePicker,
  Col,
  Card,
  Table,
  Form,
  Spin,
  Select,
  Button,
  Statistic,
} from "antd";

// PROJECT IMPORTS
import { CSVLink } from "react-csv";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import CustomButton from "../../../components/custom/CustomButton";
import { apiConfig, labelConfig, staticConfig } from "../glAndAccounting.config";
import CustomPagination from "../../../components/CustomPagination";

const Search = Input;

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {},
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const columns = [
  {
    title: "ID",
    dataIndex: "id",
  },
  {
    title: "Branch",
    dataIndex: "branch",
    sorter: (a, b) => a.branch.localeCompare(b.branch),
  },
  {
    title: "Transaction Date",
    dataIndex: "transactionDate",
    sorter: (a, b) => a.transactionDate.localeCompare(b.transactionDate),
  },
  {
    title: "Transaction Tag",
    dataIndex: "transactionTag",
  },
  {
    title: "Account",
    dataIndex: "account",
    sorter: (a, b) => a.account.localeCompare(b.account),
  },
  {
    title: "Amount",
    dataIndex: "amount",
  },
];

const SearchGLA0200 = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { RangePicker } = DatePicker;
  const { monthList } = appStatic;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [perPage, setPerPage] = useState(15);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [journalEntryList, setJournalEntryList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [officeData, setOfficeData] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [form] = Form.useForm();
  const formFields = Form.useWatch([], form);

  useEffect(() => {
    getOffice();
    getGlAccount();
    // //DISABLE ALL RIGHTSIDEBAR ACTION
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });
    // rightAction(cnt.RIGHT_ADD_BTN);
    setIsLoading(false);
  }, []);

  function getOffice() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetOfficeList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let temp = [];

        console.log(objList);

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(temp);
      }
    });
  }

  function getGlAccount() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetSpecificGLList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let temp = [];

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: element.name,
          });
        });

        setAccountData(temp);
      }
    });
  }

  // FLOAT METHODS
  function handleOnView() {
    // console.log(selectedRow);return
    delete selectedRow.amount;
    selectedRow.amount = selectedRow.amountToUse;
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-gla0200", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  const onSubmit = (formValues, offset = 0) => {
    formFields.fromDate = formFields?.date ? BOM.DateTime(formFields?.date[0], "only-date") : null;

    formFields.toDate = formFields?.date ? BOM.DateTime(formFields?.date[1], "only-date") : null;

    const params = BOM.omitNullishParams({
      dateFormat: "dd MMMM yyyy",
      fromDate: formFields?.fromDate,
      glAccountId: formFields?.glAccountId,
      limit: perPage,
      locale: "en",
      manualEntriesOnly: formFields?.manualEntriesOnly,
      officeId: formFields?.officeId,
      offset: offset,
      orderBy: "transactionDate",
      sortOrder: "DESC",
      toDate: formFields?.toDate,
      transactionId: formFields?.transactionId,
    });

    const url = `${definedApi.SearchJournalEntries}`;
    const body = {
      ...formFields,
      session,
      params,
    };

    setIsLoading(true);
    setShowSearch(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res.pageItems;
        setTotalItems(res.totalFilteredRecords);
        const tempArray = objList
          .map((element) => ({
            key: element?.id,
            id: element?.id ? element?.id : "-",
            branch: element?.officeName ? element?.officeName : "-",
            branchId: element?.officeId ? element?.officeId : "-",
            transactionDate: element?.transactionDate
              ? `${element?.transactionDate[2]} ${monthList[element?.transactionDate[1] - 1]} ${
                  element?.transactionDate[0]
                }`
              : "-",
            transactionId: element?.transactionId ? element?.transactionId : "-",
            transactionUniqueId: element?.transactionUniqueId ? element?.transactionUniqueId : "-",
            type: element?.glAccountType?.value ? element?.glAccountType?.value : "-",
            createdBy: element?.createdByUserName ? element?.createdByUserName : "-",
            account: element?.glAccountName
              ? `${element?.glAccountName} (${element?.glAccountCode})`
              : "-",
            debit: element?.entryType?.value?.toLowerCase() === "debit" ? element?.amount : "-",
            credit: element?.entryType?.value?.toLowerCase() === "credit" ? element?.amount : "-",
            transactionTag: element?.entryType?.value
              ? element?.entryType?.value === "DEBIT"
                ? "Dr"
                : element?.entryType?.value === "CREDIT"
                  ? "Cr"
                  : "-"
              : "-",
            amount: element?.amount ? (
              <Statistic value={element?.amount} precision={2} valueStyle={{ fontSize: "16px" }} />
            ) : (
              "-"
            ),
            amountToUse: element?.amount ? element?.amount : 0,
          }))
          .sort((a, b) => new Date(b.id) - new Date(a.id));

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setJournalEntryList(tempArray.filter((item) => item.disabled === false));
        setJournalEntryList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  console.log(totalItems);
  return (
    <MainLayout isEnableRightSidebar={true} onView={handleOnView}>
      <TopContent
        pageTitle={appLabel.journalEntries}
        pageItems={appStatic.searchJournalEntryItems}
      />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Form
            form={form}
            onFinish={onSubmit}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              {/* <Text>RENDER TABLE LIST HERE</Text> */}

              <Row style={{ justifyContent: "space-betwen" }}>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="officeId" label={<Text>{appLabel.branch}</Text>}>
                    <Select
                      onChange={(e) => console.log(e)}
                      options={officeData}
                      showSearch
                      placeholder={BOM.handlePlaceholderMsg(appLabel.branch)}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="glAccountId" label={<Text>{appLabel.account}</Text>}>
                    <Select
                      options={accountData}
                      placeholder={BOM.handlePlaceholderMsg(appLabel.account)}
                      allowClear
                      showSearch
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="date" label={<Text>{appLabel.dateRange}</Text>}>
                    <RangePicker style={{ width: "100%", height: 35 }} />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="manualEntriesOnly" label={<Text>{labelConfig.filter}</Text>}>
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                      }
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.filter, "select")}
                      options={staticConfig.filterOptions}
                      showSearch
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item name="transactionId" label={<Text>{labelConfig.transactionId}</Text>}>
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.transactionId)}
                      // style={styles.ofInputFieldNumber}
                    />
                  </Form.Item>
                </Col>
              </Row>
              {showSearch && (
                <>
                  <Table
                    rowSelection={{
                      type: "radio",
                      ...rowSelection,
                      onChange: onSelectItemAction,
                    }}
                    columns={columns}
                    dataSource={journalEntryList}
                    bordered
                    scroll={{ x: 800 }}
                    //   title={() => "Customers List"}
                    // pagination={{
                    //   position: "bottomCentre",
                    //   pageSize: tableCount,
                    // }}
                    pagination={false}
                  />
                  <CustomPagination
                    totalItems={totalItems}
                    pageSize={15}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    onPageChange={(page, offset) => onSubmit(formFields, offset)}
                  />
                </>
              )}
            </Card>
            <Form.Item>
              <Row>
                <CustomButton
                  content="Search"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              </Row>
            </Form.Item>
          </Form>
        </Spin>
      </Card>
    </MainLayout>
  );
};

function DownloadTableButtons(props) {
  const colSpan = 7;

  const csvData = [
    // ["Name", "Client No.", "Branch"],
    // ...tableData.map((item) => [item.name, item.clientno, item.branch]),
  ];

  return (
    <ConfigProvider
      theme={{
        components: {},
        token: {},
      }}
    >
      <Row style={{ marginLeft: "auto", marginBottom: "auto" }}>
        {" "}
        <div hidden={props.searchState} style={{ marginRight: 50 }}>
          {/* <Search
            placeholder="Search by Name or client ID..."
            onSearch={console.log("search")}
            prefix={<SearchOutlined />}
            style={{
              width: 400,
            }}
          /> */}
        </div>
        <Row>
          {" "}
          <Col style={{ width: "25%" }}>
            <Button
              style={{
                padding: 5,
                borderTopLeftRadius: 10,
                borderBottomLeftRadius: 10,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                backgroundColor: "white",
              }}
            >
              <CSVLink data={csvData} filename={"CustomerTable.csv"}>
                CSV
              </CSVLink>
            </Button>
          </Col>
          <Col style={{ width: "28%" }}>
            <Button
              style={{
                padding: 5,
                borderRadius: 0,
                backgroundColor: "white",
              }}
            >
              Excel
            </Button>
          </Col>
          <Col style={{ width: "22%" }}>
            <Button
              style={{
                padding: 5,
                borderRadius: 0,
                backgroundColor: "white",
              }}
            >
              PDF
            </Button>
          </Col>
          <Col style={{ width: "25%" }}>
            <Button
              style={{
                padding: 5,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                borderTopRightRadius: 10,
                borderBottomRightRadius: 10,
                backgroundColor: "white",
              }}
            >
              Print
            </Button>
          </Col>
        </Row>
      </Row>
    </ConfigProvider>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(SearchGLA0200);
